// extracted by mini-css-extract-plugin
export default {"navigation":"styles_navigation__izWDg"};